import { UnitType } from '@exodus/currency'

const name = 'injective'
const displayName = 'Injective'
const ticker = 'INJ'
const displayTicker = 'INJ'
const displayNetworkTicker = displayTicker
const displayNetworkName = displayName
const baseAssetName = name
const primaryColor = '#0082FA'
const gradientColors = ['#0082FA', '#01B8FC']
const gradientCoords = { x1: '0%', y1: '0%', x2: '100%', y2: '100%' }
const chainBadgeColors = gradientColors

const units = {
  ainj: 0,
  uinj: 12,
  INJ: 18,
}

const currency = UnitType.create(units)

const assetType = 'COSMOS_LIKE'
const blockExplorer = {
  addressUrl: (address) =>
    `https://www.mintscan.io/injective/account/${encodeURIComponent(address)}`,
  txUrl: (txId) => `https://www.mintscan.io/injective/txs/${encodeURIComponent(txId)}`,
}
const info = {
  description:
    'INJ is the native token for Injective, a network that supports the creation of interoperable, decentralized apps. The network is governed by INJ holders, who vote on upgrades and new listings.',
  reddit: 'https://www.reddit.com/r/injective/',
  twitter: 'https://twitter.com/Injective_',
  website: 'https://injective.com/',
  telegram: 'https://t.me/joininjective',
  discord: 'https://discord.com/invite/injective',
}

export const asset = {
  assetType,
  baseAssetName,
  baseDenom: 'inj',
  blockExplorer,
  chainBadgeColors,
  currency,
  displayName,
  displayNetworkName,
  displayNetworkTicker,
  displayTicker,
  gradientColors,
  gradientCoords,
  info,
  name,
  primaryColor,
  properName: displayName, // deprecated,
  properTicker: displayTicker, // deprecated,
  ticker,
  toString: () => name,
  units,
}

export default [asset]
